import React from 'react';
type SectionLabelProps = {
  children: React.ReactNode;
  tone?: 'ink' | 'light';
  align?: 'left' | 'center';
};
export function SectionLabel({
  children,
  tone = 'ink',
  align = 'center'
}: SectionLabelProps) {
  return <p className={['text-[11px] font-light uppercase tracking-ultra', align === 'center' ? 'text-center' : 'text-left', tone === 'ink' ? 'text-clay' : 'text-white/80'].join(' ')} data-id="element-160" data-mp="2yg41iqw4zo6r">
      {children}
    </p>;
}